module.exports = __webpack_public_path__ + "static/media/Watermelon.43010be5.svg";